import React from 'react'
import MaterialSymbol from '../material-symbol'

const CheckCircle = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="check_circle" {...props} />
))

CheckCircle.displayName = 'CheckCircle'

export default CheckCircle
